<!--
Author: jiangli
Date: 2024-05-07
Desc: 组合定投
 -->
<template>
    <div class="pt20 pb20 pl20 pr25 pr20">
        <div v-if="plans.length > 0">
            <div v-for="(item, index) in plans" :key="index">
                <div
                    class="bc_FFF6F6 bor_b_FFD8D8 pt35 pb35 pl16 pr16 fs20 c_333 br4 flex between hcenter"
                >
                    <div class="flex hcenter">
                        <div class="mr12 bold">{{ item.portfolioname }}</div>
                        <div class="flex hcenter pointer" v-on:click="item.expand = !item.expand">
                            <div class="c_1890FF fs16">{{ item.expand ? "收起" : "展开" }}</div>
                            <img
                                src="../../assets/img/triangle-down.svg"
                                class="w14 h10 ml4"
                                :class="[item.expand ? '' : 'rotate180']"
                            />
                        </div>
                    </div>
                    <div
                        class="bc_E60012 c_ffffff fs14 lin22 pl25 pr25 pt10 pb10 pointer"
                        v-on:click="goPlan(item)"
                    >
                        立即定投
                    </div>
                </div>
                <div v-show="item.expand" class="pt20 pb40 flex between">
                    <div>
                        <div class="flex hcenter mb20">
                            <div class="w3 h16 bc_E60012 mr6"></div>
                            <div class="fs18">我的资产</div>
                        </div>
                        <div class="bc_F9F9F9 w356 h320">
                            <div :id="'echart' + index" class="w356 h320"></div>
                        </div>
                    </div>

                    <div>
                        <div class="flex hcenter mb20">
                            <div class="w3 h16 bc_E60012 mr6"></div>
                            <div class="fs18">组合特色</div>
                        </div>
                        <div class="bc_F9F9F9 pt20 pl16 pr16 pb64 mb20 fs18 w784 border-box">
                            {{ item.feature }}
                        </div>
                        <div class="flex hcenter mb20">
                            <div class="w3 h16 bc_E60012 mr6"></div>
                            <div class="fs18">适宜对象</div>
                        </div>
                        <div class="bc_F9F9F9 pt20 pl16 pr16 pb64 mb20 fs18 w784 border-box">
                            {{ item.availobject }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>暂无组合信息</div>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import * as echarts from "echarts";
import fundApi from "@/api/fund";
import fundSdxDialog from "@/components/form/fundSdxDialog";

export default {
    name: "Combofund",
    components: { fundSdxDialog },
    data() {
        return {
            plans: [],
            sdxFundInfo: {},
            sdxDialogVisible: false
        };
    },

    mounted() {
        this.qryCombinationInfo(); // 临时注释
    },

    methods: {
        async qryCombinationInfo() {
            const res = await fundApi.qryCombinationInfo();
            if (res.data) {
                this.plans = res.data;
                this.plans.forEach((item) => {
                    this.$set(item, "expand", false);
                });
                this.$nextTick(() => {
                    this.initChart();
                });
            }
        },
        // 初始化饼图
        initChart() {
            this.plans.forEach((item, index) => {
                let myChart = echarts.init(document.getElementById("echart" + index));
                let funds = [];
                item.subfundinfos.forEach((item1) => {
                    funds.push({
                        value: item1.ratio,
                        name: item1.fundname
                    });
                });
                let option = {
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}（{d}%）"
                    },
                    series: [
                        {
                            type: "pie",
                            hoverAnimation: false,
                            color: ["#ffb52b", "#f97170", "#7189fe"],
                            data: funds,
                            radius: ["17%", "60%"],
                            label: {
                                normal: {
                                    show: true,
                                    position: "inside", // 标签显示的位置，'outside' 表示标签在扇形外侧
                                    formatter: "{d}%", // 标签文本格式器
                                    color: "#ffffff"
                                }
                            }
                        },
                        {
                            type: "pie",
                            hoverAnimation: false,
                            color: ["#ffb52b", "#f97170", "#7189fe"],
                            data: funds,
                            radius: ["17%", "60%"],
                            label: {
                                normal: {
                                    show: true,
                                    position: "outside", // 标签显示的位置，'outside' 表示标签在扇形外侧
                                    formatter: "{b}" // 标签文本格式器
                                },
                                emphasis: {
                                    show: true,
                                    formatter: "{b}"
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true // 是否显示标签的引导线
                                }
                            },
                            labelLayout: {
                                hideOverlap: false
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            });
        },
        // 设置组合定投
        goPlan(item) {
            this.sdxFundInfo = {};
            this.$util.fundRiskCheck(this, item, (res) => {
                if (res) {
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, res, { way: "59", isCom: true });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            sessionStorage.setItem("generalbuy", JSON.stringify(this.sdxFundInfo));
            this.$router.push({ name: "generalbuy", query: { isCom: "1" } });
        }
    }
};
</script>

<style lang="scss" scoped></style>
